<ul class="grid-view">
    <li id="outage-btn"  [ngClass]="outage ? 'active' : 'notactive'" ><a (click)="outagecolor()" routerLink="/devopsoutageform" id="outage-link">Outage</a></li>
    <li id="release-btn"  [ngClass]="release ? 'active' : 'notactive'" ><a (click)="releasecolor()" routerLink="/devopsreleasenotes" id="release-link">Release Notes</a></li>
    <li class="logout-btn" id="logout"><a (click)="logout()" routerLink="">Logout</a></li>
  </ul>